import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
    name: 'ngcRelativeDate'
})
export class RelativeDatePipe implements PipeTransform {

    transform(value: Date | string, ...args: unknown[]): unknown {
        return moment(value).startOf('minute').fromNow();
    }

}


